type ActiveAudioListener = (activeId: number | null) => void

let activeAudioId: number | null = null
let audioInstanceSeed = 0
const activeAudioListeners = new Set<ActiveAudioListener>()

const notifyActiveAudioChange = () => {
    activeAudioListeners.forEach(listener => {
        listener(activeAudioId)
    })
}

export const createAudioInstanceId = () => {
    audioInstanceSeed += 1
    return audioInstanceSeed
}

export const claimActiveAudio = (instanceId: number) => {
    if (activeAudioId === instanceId) {
        return
    }
    activeAudioId = instanceId
    notifyActiveAudioChange()
}

export const releaseActiveAudio = (instanceId: number) => {
    if (activeAudioId !== instanceId) {
        return
    }
    activeAudioId = null
    notifyActiveAudioChange()
}

export const subscribeActiveAudio = (listener: ActiveAudioListener) => {
    activeAudioListeners.add(listener)
    return () => {
        activeAudioListeners.delete(listener)
    }
}
